<nz-spin [nzSpinning]="loading$ | async">
  <form
    [formGroup]="organizationContactForm"
    (ngSubmit)="onSubmit($event)"
    nz-form
    class="add-org-form form"
    nzLayout="vertical">
    <div class="drawer-form-wrapper">
      <nz-form-item>
        <nz-form-label nzFor="firstName" [nzRequired]="!isViewMode"
          >First Name</nz-form-label
        >
        <nz-form-control [nzErrorTip]="firstNameErrorTpl">
          <input
            type="text"
            nz-input
            formControlName="firstName"
            placeholder="Enter your first name" />
          <ng-template #firstNameErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"
              >First name is required</ng-container
            >
            <ng-container *ngIf="control.hasError('minlength')"
              >First name must be at least 2 characters</ng-container
            >
            <ng-container *ngIf="control.hasError('maxlength')"
              >First name cannot exceed 50 characters</ng-container
            >
            <ng-container *ngIf="control.hasError('pattern')">
              First name can't include special characters
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="lastName" [nzRequired]="!isViewMode"
          >Last Name</nz-form-label
        >
        <nz-form-control [nzErrorTip]="lastNameErrorTpl">
          <input
            type="text"
            nz-input
            formControlName="lastName"
            placeholder="Enter your last name" />
          <ng-template #lastNameErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"
              >Last name is required</ng-container
            >
            <ng-container *ngIf="control.hasError('minlength')"
              >Last name must be at least 2 characters</ng-container
            >
            <ng-container *ngIf="control.hasError('maxlength')"
              >Last name cannot exceed 50 characters</ng-container
            >
            <ng-container *ngIf="control.hasError('pattern')">
              Last name can't include special characters
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="title" [nzRequired]="!isViewMode"
          >Title</nz-form-label
        >
        <nz-form-control [nzErrorTip]="titleErrorTpl">
          <input
            type="text"
            nz-input
            formControlName="title"
            placeholder="Enter your title" />
          <ng-template #titleErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"
              >Title is required</ng-container
            >
            <ng-container *ngIf="control.hasError('maxlength')"
              >Title cannot exceed 100 characters</ng-container
            >
            <ng-container *ngIf="control.hasError('pattern')">
              Title can't include special characters
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="email" [nzRequired]="!isViewMode"
          >Email</nz-form-label
        >
        <nz-form-control [nzErrorTip]="emailErrorTpl">
          <input
            type="email"
            nz-input
            formControlName="email"
            placeholder="Enter your email address" />
          <ng-template #emailErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"
              >Email is required</ng-container
            >
            <ng-container *ngIf="control.hasError('email')"
              >Please enter a valid email address</ng-container
            >
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="primaryPhone" [nzRequired]="!isViewMode"
          >Primary Phone</nz-form-label
        >
        <nz-form-control [nzErrorTip]="primaryPhoneErrorTpl">
          <input
            type="tel"
            nz-input
            formControlName="primaryPhone"
            placeholder="Enter primary phone number" />
          <ng-template #primaryPhoneErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"
              >Primary phone is required</ng-container
            >
            <ng-container *ngIf="control.hasError('pattern')"
              >Please enter a valid phone number format</ng-container
            >
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="secondaryPhone">Secondary Phone</nz-form-label>
        <nz-form-control [nzErrorTip]="secondaryPhoneErrorTpl">
          <input
            type="tel"
            nz-input
            formControlName="secondaryPhone"
            placeholder="Enter secondary phone number" />
          <ng-template #secondaryPhoneErrorTpl let-control>
            <ng-container *ngIf="control.hasError('pattern')"
              >Please enter a valid phone number format</ng-container
            >
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <div class="display-flex justify-content-between drawer-footer">
        <button
          *ngIf="!isAddMode"
          type="button"
          nz-button
          nzType="default"
          (click)="showDeleteModal()">
          Delete
        </button>

        <button
          *ngIf="isAddMode"
          type="button"
          nz-button
          nzType="default"
          (click)="closeContactDrawer()">
          Cancel
        </button>

        <ng-container [ngSwitch]="true">
          <button
            *ngSwitchCase="isViewMode"
            type="button"
            nz-button
            nzType="primary"
            (click)="onEditContactFormOrganization()">
            Edit
          </button>

          <button
            *ngSwitchCase="
              isEditMode || orgParams.mode === OrganizationMode.ADD_CONTACT
            "
            nz-button
            nzType="primary"
            [disabled]="!organizationContactForm.valid"
            [nzLoading]="loading$ | async">
            {{
              orgParams.mode === OrganizationMode.ADD_CONTACT
                ? 'Submit'
                : 'Save'
            }}
          </button>
        </ng-container>
      </div>
    </div>
  </form>
</nz-spin>
<app-confirm-dialog
  [isVisible]="isVisible"
  [title]="'Delete Contact'"
  [message]="
    'Are you sure you want to delete this Contact? This action cannot be undone.'
  "
  [iconSrc]="'/assets/icon/icon-trash-red.svg'"
  [iconColor]="'red'"
  [cancelText]="'Cancel'"
  [loading]="(loading$ | async) || false"
  [confirmText]="'Delete'"
  (confirmed)="handleOkMiddle()"
  (cancelled)="handleCancelMiddle()"
  (closed)="handleCancelMiddle()">
</app-confirm-dialog>
